import { render, staticRenderFns } from "./createGrCert.vue?vue&type=template&id=bd00022a&scoped=true&"
import script from "./createGrCert.vue?vue&type=script&lang=js&"
export * from "./createGrCert.vue?vue&type=script&lang=js&"
import style0 from "./createGrCert.vue?vue&type=style&index=0&id=bd00022a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd00022a",
  null
  
)

component.options.__file = "createGrCert.vue"
export default component.exports